"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createParam = exports.ClientParamList = void 0;
/* eslint-disable no-param-reassign */
const spu_1 = require("../../spu");
const enums_1 = require("../enums");
/**
 * 扁平交易参数，包含普通参数、用量参数、交易参数和引用部件参数
 */
exports.ClientParamList = {
    /** 从 SPU 引用树构建扁平交易参数列表 */
    fromSpuTree: (tree, externalParameterList = []) => fromSpuTree(tree, [], externalParameterList),
};
function fromSpuTree(spuNode, ancestorPath = [], externalParameterList = []) {
    const { Spu: spuMeta, SpecNodeList: specNodeList } = spuNode;
    const spu = Object.assign(Object.assign({}, spuMeta), { SpecList: specNodeList.map(x => x.Spec) });
    // 根据规格创建节点
    const result = [];
    // 记录链表关系
    let last = null;
    const push = (param) => {
        result.push(param);
        param.prev = last;
        if (last) {
            last.next = param;
        }
        last = param;
    };
    const parent = ancestorPath.at(-1) || null;
    const create = (paramType, spec, isRef) => createParam({
        spu,
        ancestorPath,
        paramType,
        spec,
        isRef,
        parent,
    });
    // 创建数量和用量节点，跟节点的处理有所不同
    const { baseName, minValue } = parent
        ? { baseName: parent.spec.SpecName, minValue: 0 }
        : { baseName: '订购', minValue: 1 };
    push(create(enums_1.ParamTypeEnum.Quantity, {
        SpecCode: 'sys_quantity',
        SpecName: `数量`,
        SpecValueType: spu_1.ValueTypeEnum.Int,
        ValueRestrictionList: [
            {
                RestrictionType: spu_1.RestrictionEnum.Range,
                RestrictionRuleList: [{ Min: minValue, Max: 99999999, Step: 1 }],
            },
        ],
        SpecValueUnit: spu.QuantityUnit === 'None' ? '' : spu.QuantityUnit,
    }));
    // push(
    //   create(ParamTypeEnum.Measure, {
    //     SpecCode: 'sys_measure',
    //     SpecName: spu.MeasureName || `用量`,
    //     SpecValueType: ValueTypeEnum.Decimal,
    //     ValueRestrictionList: [
    //       {
    //         RestrictionType: RestrictionEnum.Range,
    //         RestrictionRuleList: [{ Min: minValue, Max: 99999999, Step: 1 }],
    //       },
    //     ],
    //     SpecValueUnit: spu.MeasureUnit,
    //   }),
    // );
    // 自身参数，每个参数创建一个节点
    for (const node of specNodeList.filter(x => !isRef(x.Spec))) {
        push(create(enums_1.ParamTypeEnum.Spec, node.Spec));
    }
    // 如果有额外扩展参数，批量创建节点
    for (const externalParameter of externalParameterList) {
        push(create(enums_1.ParamTypeEnum.ExternalParameter, externalParameter));
    }
    // 部件节点递归创建
    for (const node of specNodeList.filter(x => isRef(x.Spec))) {
        const refs = node.ReferenceSpuNodeList || [];
        const param = create(enums_1.ParamTypeEnum.Spec, node.Spec, true);
        push(param);
        for (const ref of refs.map(spu => fromSpuTree(spu, param.paramPath)).flat()) {
            push(ref);
        }
    }
    return result;
}
function isRef(spec) {
    return spec.SpecValueType === spu_1.ValueTypeEnum.Ref || spec.SpecValueType === spu_1.ValueTypeEnum.RefArray;
}
function createParam({ spu, spec, paramType, ancestorPath, isRef = false, parent, }) {
    const depth = ancestorPath.length;
    const param = {
        spu,
        spec,
        paramType,
        isRef,
        isMeasure: spec.SpecCode === spu.MeasureSpecCode,
        depth,
        // path 和 key 需要引用自身，稍后赋真实值
        paramPath: [],
        paramKey: 'spec://',
        parent,
        // 链表关系，不在这里构建
        next: null,
        prev: null,
    };
    param.paramPath = [...ancestorPath, param];
    param.paramKey = createParamKey(param, ancestorPath);
    return param;
}
exports.createParam = createParam;
function createParamKey(param, ancestorPath) {
    const visitSpec = (path) => path.map(x => `${x.spu.SpuCode}.${x.spec.SpecCode}`);
    let parts = [];
    switch (param.paramType) {
        case enums_1.ParamTypeEnum.Spec:
        case enums_1.ParamTypeEnum.ExternalParameter: {
            parts = visitSpec([...ancestorPath, param]);
            break;
        }
        case enums_1.ParamTypeEnum.Quantity: {
            parts = [...visitSpec(ancestorPath), param.spu.SpuCode];
            break;
        }
    }
    return `${param.paramType}://${parts.join('>')}`;
}
